var React = require('react');

function SignatureInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-59 212.469C-1.4 247.669 73 358 382 296.351C481 271.187 654.25 178.913 662.5 78.2602C670.75 -22.3921 547 19.5359 514 111.808C481 204.08 472.75 321.516 588.25 296.351C703.75 271.187 728.5 145.365 736.75 212.469C743.913 270.733 728.5 321.516 778 296.351C827.5 271.187 852.25 262.801 893.5 296.351C962.5 362.068 1048 472 1330 393.5","stroke":"#F4EAE0","strokeWidth":"38.0904"}));
}

SignatureInline.defaultProps = {"width":"1280","height":"440","viewBox":"0 0 1280 440","fill":"none","role":"img","aria-label":""};

module.exports = SignatureInline;

SignatureInline.default = SignatureInline;
